import styled from "@emotion/styled";
import { Grid } from "@mui/material";

const StyledGridCenterAlign = styled(Grid)({
  textAlign: "center",
});

export default StyledGridCenterAlign;
